(() => {
  const initStickyAtc = (root = document) => {
    const bars = root.querySelectorAll('[data-luma-sticky-atc]');
    if (!bars.length) return;

    bars.forEach((bar) => {
      if (bar.dataset.lumaStickyReady === 'true') return;
      bar.dataset.lumaStickyReady = 'true';
      const trigger = bar.querySelector('[data-luma-sticky-atc-trigger]');
      const productInfo = bar.closest('product-info') || document.querySelector('product-info');

      const getMainSubmit = () =>
        productInfo?.querySelector('.product-form__submit:not(.luma-sticky-atc__button)');

      const syncButton = () => {
        const mainSubmit = getMainSubmit();
        if (!mainSubmit || !trigger) return;

        trigger.disabled = mainSubmit.disabled;
        const sourceLabel = mainSubmit.querySelector('span')?.textContent?.trim();
        const targetLabel = trigger.querySelector('span');
        if (sourceLabel && targetLabel) targetLabel.textContent = sourceLabel;
      };

      const syncStickyVisibility = (mainSubmitVisible) => {
        bar.hidden = mainSubmitVisible;
        document.body.classList.toggle(
          'luma-has-sticky-atc',
          Array.from(document.querySelectorAll('[data-luma-sticky-atc]')).some((item) => !item.hidden)
        );
      };

      const mainSubmit = getMainSubmit();
      if (mainSubmit && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          ([entry]) => syncStickyVisibility(entry.isIntersecting || entry.boundingClientRect.top > 0),
          { threshold: 0.1 }
        );
        observer.observe(mainSubmit);
      } else {
        syncStickyVisibility(true);
      }

      trigger?.addEventListener('click', () => {
        const mainSubmit = getMainSubmit();
        if (!mainSubmit || mainSubmit.disabled) return;
        mainSubmit.click();
      });

      productInfo?.addEventListener('change', () => window.setTimeout(syncButton, 80));
      syncButton();
    });
  };

  const normalize = (value) => (value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

  const activateMediaForInput = (input) => {
    const productInfo = input.closest('product-info');
    const variantSelects = input.closest('variant-selects');
    const sectionId = variantSelects?.dataset.section || productInfo?.dataset.section;
    const gallery = productInfo?.querySelector('media-gallery');
    if (!gallery || !sectionId) return;

    let target = null;
    const mediaId = input.dataset.lumaMediaId;

    if (mediaId) {
      target = `${sectionId}-${mediaId}`;
    } else {
      const label = normalize(input.dataset.lumaOptionLabel);
      const handle = normalize(input.dataset.lumaOptionHandle);
      const match = Array.from(gallery.querySelectorAll('[data-target]')).find((item) => {
        const alt = normalize(item.querySelector('img')?.getAttribute('alt'));
        return alt && ((label && alt.includes(label)) || (handle && alt.includes(handle)));
      });
      target = match?.dataset.target;
    }

    if (!target) return;
    gallery.setActiveMedia?.(target, true);
  };

  const initVariantMedia = (root = document) => {
    root.querySelectorAll('variant-selects input[type="radio"]').forEach((input) => {
      if (input.dataset.lumaVariantMediaReady === 'true') return;
      input.dataset.lumaVariantMediaReady = 'true';

      input.addEventListener('change', () => {
        if (!input.checked) return;
        activateMediaForInput(input);
        window.setTimeout(() => activateMediaForInput(input), 250);
      });
    });
  };

  const init = (root = document) => {
    initStickyAtc(root);
    initVariantMedia(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('product-info:loaded', (event) => init(event.target));
})();
